<template>
	<Layout>
		<div class="l-container">
			<LeagueVideoCenter
				:teams="teams"
				:recommended="recommended"
				:league-id="leagueId"
			/>
		</div>
	</Layout>
</template>

<script>
import Layout from '@js/Views/Layout';
import LeagueVideoCenter from '@js/components/EventListing/LeagueVideoCenter.vue';

export default {
	name:       'ViewVideoCenterLeague',
	components: { Layout, LeagueVideoCenter },
	props:      {
		teams: {
			type:     Array,
			required: true,
		},
		recommended: {
			type:    Array,
			default: () => [],
		},
		leagueId: {
			type:     Number,
			required: true,
		},
	},
};
</script>

<style>

</style>
